import { Module } from 'vuex';
import { Actor, Character, IRootState } from '@types';

import Env from '@lib/Env';

import { ACharacterApi } from '@/api';
import { ACharacterModel } from '@model';

// !!! Don't change order of properties !!!
export const defaultCharacterFilters = <Actor.Filters>{
    pohlavie: 'm',
    hlboky: false,
    vysoky: false,
    is_top_30: false,
    drsny: false,
    amatersky: false,
    detsky: false,
    age_from: null,
    age_to: null,
    jazyk: 1,
    price_to: null,
    type: 1,
    photo: false,
    location_id: null,
};

export const defaultCharacter = <any>{
    id: null,
    id_projekt: null,
    meno: '',
    farba: null,
    filter: { ...defaultCharacterFilters },
    candidates: [],
};

const store: Module<any, IRootState> = {
    state: {
        character: <ACharacterModel>{},
        colors: [],
        searchIsVisible: true,
    },

    mutations: {
        setColors: (state, colors: []) => (state.colors = colors),
        setCharacterMutation: (state, character: ACharacterModel) => (state.character = character),
        setCharacterColors: (state, colors: any[]) => (state.colors = colors),
        setSearchIsVisible: (state, val: boolean) => (state.searchIsVisible = val),
    },

    getters: {
        getColors: (state): [] => state.colors,
        getSelectedCharacter: (state): ACharacterModel => state.character,
        getColorById(state) {
            return (color_id: number) => {
                if (!color_id || !state.colors[color_id - 1] || !state.colors[color_id - 1].farba) {
                    return 'transparent';
                }

                return state.colors[color_id - 1].farba.replace('0x', '#');
            };
        },
        getSearchIsVisible: (state): boolean => state.searchIsVisible,
    },

    actions: {
        setCharacter: ({ dispatch, commit, rootGetters }, character: ACharacterModel) => {
            commit('setCharacterMutation', character);
            commit('setSearchIsVisible', false);
        },

        storeCharacter({ dispatch, commit, getters }, new_character: Character): Promise<boolean> {
            return new Promise((resolve, reject) => {
                ACharacterApi.storeCharacter(new_character)
                    .then((response) => {
                        if (response.data.status) {
                            new_character.id = response.data.id;
                            dispatch('loadProjectAndSelectCharacter', {
                                project_id: new_character.id_projekt,
                                character_id: response.data.id,
                            });
                        }
                        resolve(response.data.status);
                    })
                    .catch((err) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        updateCharacter({ commit }, character: Character): Promise<boolean> {
            return new Promise((resolve, reject) => {
                ACharacterApi.updateCharacter(character)
                    .then((response) => {
                        if (response.data.status) {
                            commit('updateCharacterToProject', character);
                            commit('setProjectCharacterCandidates', character);
                        }
                        resolve(response.data.status);
                    })
                    .catch((err) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        removeCharacter({ commit }, character: Character): Promise<boolean> {
            return new Promise((resolve, reject) => {
                ACharacterApi.removeCharacter(character)
                    .then((response) => {
                        if (response.data.status) {
                            commit('removeCharacterFromProject', character);
                        }
                        resolve(response.data.status);
                    })
                    .catch((err) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        loadCharacterColors({ commit }): Promise<any[]> {
            return new Promise((resolve, reject) => {
                ACharacterApi.loadCharacterColors()
                    .then((response: any) => {
                        commit('setCharacterColors', response.data.records);
                        resolve(response.data.records);
                    })
                    .catch((err: any) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },
    },
};

export default store;
